import mockAxios, { AxiosResponse } from 'axios';

import { IWorkgroupServiceMock } from './workgroup.mock.types';

export const mockWorkgroupService = (): IWorkgroupServiceMock => ({
  fetchWorkgroups: jest.fn(),
  fetchWorkgroup: jest.fn(),
  createWorkgroup: jest.fn(),
  updateWorkgroup: jest.fn(),
  deleteWorkgroup: jest.fn()
});

export const mockWorkgroupAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
